// extracted by mini-css-extract-plugin
export default {"form":"create-client_form__il4mm","fields":"create-client_fields__YpBTb","containerField":"create-client_containerField__F8J9r","buttons":"create-client_buttons__rmb5p"};